export { SkyResourceService } from './src/service/resource';
export { SkyResourceModule } from './src/module';
export {
  ISkyResourceConfig,
  ISkyResourceImage,
  ISkyResourceAudio,
  ISkyResourceVideo,
  SkyResourceWordCard,
  TSkyResourceVideoQuality,
  TSkyResourceVideoSources,
} from './src/interface';
